import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
const initialState: any = {
  auditLog: [],
  isLoading: false,
};

export const getAuditsLog:any = createAsyncThunk<any>("logs?/setAuditsLog",async (endPoint:any) => {
    const response = await ApiClient.get(endPoint);
    return response;
});
const getAuditsLogSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    setAuditsLogSlice(state, action) {
      state.auditLog = action.payload;
    }, 
  },
  extraReducers: (builder) => {
    builder.addCase(getAuditsLog.pending, (state) => {
      state.isLoading=true
    });
    builder.addCase(getAuditsLog.fulfilled, (state, action: PayloadAction<any>) => {
      state.auditLog = action.payload;
      state.isLoading=false
    });
    builder.addCase(getAuditsLog.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { setAuditsLogSlice } = getAuditsLogSlice.actions;
export default getAuditsLogSlice;



